module.exports = __webpack_public_path__ + "img/PyramidRisingx33.52b34904.png";